(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sah-product-information"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sah-product-information')) {
    customElements.define('sah-product-information', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const source = this.querySelector('.sah-info-source');
        if (!source) return;
        const copy = source.cloneNode(true);
        copy.querySelectorAll('meta').forEach(node => node.remove());
        copy.querySelectorAll('*').forEach(node => {
          node.removeAttribute('class');
          node.removeAttribute('style');
          node.removeAttribute('tabindex');
          [...node.attributes].filter(attr => attr.name.startsWith('data-aos')).forEach(attr => node.removeAttribute(attr.name));
        });
        const units = [];
        const flatten = node => {
          if (node.nodeType === Node.TEXT_NODE) {
            if (node.textContent.trim()) { const p = document.createElement('p'); p.textContent = node.textContent; units.push(p); }
            return;
          }
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (!node.textContent.trim() && !node.querySelector('img,video,iframe') && !node.matches('img,video,iframe')) return;
          if (node.tagName === 'DIV' && node.querySelector('div,p,ul,ol,h1,h2,h3,h4,table')) {
            [...node.childNodes].forEach(flatten);
          } else if (node.tagName === 'DIV') {
            const p = document.createElement('p'); p.append(...node.childNodes); units.push(p);
          } else units.push(node);
        };
        [...copy.childNodes].forEach(flatten);
        if (!units.length) return;
        const groups = [];
        let current = { title:this.dataset.overview, kind:'intro', nodes:[] };
        groups.push(current);
        for (const node of units) {
          const text = node.textContent.trim();
          const heading = !/^\[?PILL FOBS? (?:SOLD SEPARATELY|NOT INCLUDED)/.test(text) && (/^H[1-6]$/.test(node.tagName) || (text.length < 85 && /^(key features|features|material|dimensions|finishing|important information|more than just a keychain|presentation-ready)[:.!]?$/i.test(text)));
          if (heading) {
            let kind = /features/i.test(text) ? 'features' : /material|dimensions|finishing/i.test(text) ? 'spec' : /important/i.test(text) ? 'important' : 'section';
            current = { title:text, kind, nodes:[] }; groups.push(current);
          } else if (/^(?:\[?PILL FOBS? (?:SOLD SEPARATELY|NOT INCLUDED)|Important:.*(?:NOT|not).*include)/.test(text)) {
            groups.push({title:this.dataset.important, kind:'important', nodes:[node]});
          } else if (/^Doctors recommend/i.test(text)) {
            groups.push({title:this.dataset.aspirin, kind:'aspirin', nodes:[node]});
          } else if (/^\*\s*ASA|^\*\s*Always allow/i.test(text) && current.kind !== 'important') {
            let important = groups.find(group => group.kind === 'important');
            if (!important) { important = { title:this.dataset.important, kind:'important', nodes:[] }; groups.push(important); }
            important.nodes.push(node);
          } else current.nodes.push(node);
        }
        const layout = document.createElement('div'); layout.className = 'sah-info-layout';
        const panel = (group, collapse = false) => {
          const box = document.createElement(collapse ? 'details' : 'section');
          box.className = 'sah-info-panel sah-info-panel--' + group.kind;
          const title = document.createElement(collapse ? 'summary' : 'h3');
          title.className = 'sah-info-heading'; title.textContent = group.title;
          const body = document.createElement('div'); body.className = 'sah-info-body'; body.append(...group.nodes);
          box.append(title,body); return box;
        };
        let specs;
        for (const group of groups) {
          if (!group.nodes.length) {
            if (group.kind !== 'intro') { const p = document.createElement('p'); p.textContent = group.title; layout.append(p); }
            continue;
          }
          if (group.kind === 'intro' && group.nodes.length > 1) {
            layout.append(panel({...group,nodes:[group.nodes[0]]}));
            layout.append(panel({title:this.dataset.more,kind:'background',nodes:group.nodes.slice(1)},true));
          } else if (group.kind === 'spec') {
            if (!specs) { specs = document.createElement('div'); specs.className = 'sah-info-specs'; layout.append(specs); }
            specs.append(panel(group));
          } else layout.append(panel(group));
        }
        const materials = this.querySelector('[data-sah-materials]');
        if (materials) {
          const intro = layout.querySelector('.sah-info-panel--intro');
          if (intro) intro.after(materials); else layout.prepend(materials);
        }
        source.replaceWith(layout);
        this.dataset.ready = 'true';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
